import { observable, action, runInAction, toJS } from "mobx";
import { imgToPdf } from "imgtopdf";
import jsPDF from 'jspdf';
import moment from "moment";
import defaultRoomsData from "./Rooms/data";
import defaultFoodData from "./Food/data";
import compute from "./compute";
import { message } from "antd";

export const defaultDayData = [{
    name: "Grand Total<br/>总计",
    other_day: 0,
    other_last: 0,
    rev_day: 0,
    rev_last: 0,
}];

class Store {
    @observable print = false;
    @observable loading = false;
    @observable saveLoading = false;
    @observable roomData = [];
    @observable foodData = [];
    @observable dayData = [...defaultDayData];
    @observable date = moment().format('YYYY-MM');

    @action
    getData = async (date) => {
        runInAction(() => {
            this.loading = true;
            this.roomData = [];
            this.foodData = [];
            this.dayData = [];
        });
        try {
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');
            let roomData = JSON.parse(JSON.stringify(defaultRoomsData));
            let foodData = JSON.parse(JSON.stringify(defaultFoodData));
            let dayData = JSON.parse(JSON.stringify(defaultDayData));

            const url = `/dayMonth?year=${year}&month=${month}`;
            const json = await fetch(url, { credentials: 'include' })
            const res = await json.json();

            if (res.data.food) {
                foodData = Object.entries(res.data.food).map(v => ({ ...v[1], name: v[0] }));
            }
            if (res.data.room) {
                roomData = Object.entries(res.data.room).map(v => ({ ...v[1], name: v[0] }));
            }
            if (res.data.total) {
                dayData = [{ ...res.data.total }];
            }

            await this.onChange({ roomData, foodData, dayData });

            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify({ roomData, foodData, dayData }));
            dataFrom.append('year', year);
            dataFrom.append('month', month);
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            const saveres = await fetch('/dayMonthSave', headres);
            await saveres.json();

            runInAction(() => {
                this.loading = false;
            })

        } catch (error) {
            runInAction(() => { this.loading = false });
            console.log(error);
        }
    }

    @action
    aKeyToSave = async (date) => {
        runInAction(() => {
            this.loading = true;
            this.print = true;
        });
        try {
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');


            const url = `/getAll/dayMonth?year=${year}&month=${month}`;
            const json = await fetch(url, { credentials: 'include' })
            const res = await json.json();
            let dataAll = [];

            for (let index = 0; index < res.data.length; index++) {
                const item = res.data[index];
                let roomData = JSON.parse(JSON.stringify(defaultRoomsData));
                let foodData = JSON.parse(JSON.stringify(defaultFoodData));
                let dayData = JSON.parse(JSON.stringify(defaultDayData));


                if (item.food) {
                    foodData = Object.entries(item.food).map(v => ({ ...v[1], name: v[0] }));
                }
                if (item.room) {
                    roomData = Object.entries(item.room).map(v => ({ ...v[1], name: v[0] }));
                }
                if (item.total) {
                    dayData = [{ ...item.total }];

                }
                dataAll.push({
                    comid: item.id,
                    year,
                    month,
                    foodData,
                    roomData,
                    dayData
                })
            }


            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(dataAll));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }
            const saveres = await fetch('/saveAll/dayMonthSave', headres);
            await saveres.json();

            message.success('全部酒店数据保存成功！');
            runInAction(() => {
                this.loading = false;
                this.print = false;
            })

        } catch (error) {
            runInAction(() => { this.loading = false; this.print = false });
            console.log(error);
        }
    }

    @action
    onChange = ({ roomData, foodData, dayData }) => {
        const data = compute({ roomData, foodData, dayData });
        this.roomData = data.roomData;
        this.foodData = data.foodData;
        this.dayData = data.dayData;
    }

    @action
    download = async () => {
        runInAction(() => { this.print = true });
        try {
            const res = await imgToPdf('daily', 1.5);
            let canvas = res.canvas;
            var pageData = canvas.toDataURL('image/png', 0.7);

            //方向默认横向，尺寸ponits, 按照图片大小进行输出
            var pdf = new jsPDF('l', 'pt', [canvas.width, canvas.height]);
            //需要dataUrl格式
            pdf.addImage(pageData, 'PNG', 0, 0, canvas.width, canvas.height);
            pdf.save(`Daily Revenue Report 每日经营报表.pdf`);
            runInAction(() => { this.print = false });
        } catch (error) {
            runInAction(() => { this.print = false });
            console.error(error);
        }
    }


}

const daily = new Store();

export default daily;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.1/store.js